export enum EThemeVariants {
    SIMPLE = 'simple',
    WEBSITE = 'website',
}
